import { IPackage, Package } from "./package.model";

export interface IPackagesResponse {
  pending: IPackage[];
  historical: IPackage[];
}

export class PackagesResponse {

  pending: Package[];
  historical: Package[];

  [key: string]: Package[];

  constructor(
    data: IPackagesResponse
  ) {
    this.pending = data.pending.map(
      (item) => new Package(item)
    );
    this.historical = data.historical.map(
      (item) => new Package(item)
    );
  }
}
